const actions = {
    GET_INVOICE: 'GET_INVOICE',
    GET_INVOICE_SUCCESS: 'GET_INVOICE_SUCCESS',
    GET_INVOICE_FAIL: 'GET_INVOICE_FAIL',
}

export default actions;

export const getInvoiceList = () => ({ type: actions.GET_INVOICE })
